import watchAddressInfo from './addressInfo'

export default watchAddressInfo
